import { render } from "./HeaderCompareProducts.vue?vue&type=template&id=7abe218b"
import script from "./HeaderCompareProducts.vue?vue&type=script&lang=js"
export * from "./HeaderCompareProducts.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__